import React, {Suspense} from 'react'
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {AuthRoute} from './auth.routes'

const Login = React.lazy(() => import('../screens/Login'))
const Register = React.lazy(() => import('../screens/Register'))
const UserRegister = React.lazy(() => import('../screens/User/UserRegister'))
const RegistrationData = React.lazy(() => import('../screens/RegistrationData'))
const UserList = React.lazy(() => import('../screens/User/UserList'))
const UserDetails = React.lazy(() => import('../screens/User/UserDetails'))
const GroupList = React.lazy(() => import('../screens/Group/GroupList'))
const GroupDetails = React.lazy(() => import('../screens/Group/GroupDetails'))
const PassRecoverSentEmail = React.lazy(() => import('../screens/Login/utils/RecoverPassSendEmail'))
const PassRecoverChange = React.lazy(() => import('../screens/Login/utils/RecoverPassChange'))
const GroupKnowledge = React.lazy(() => import('../screens/Group/GroupKnowledge'))
const Dashboard = React.lazy(() => import('../screens/Dashboard'))
const TermsOfUse = React.lazy(() => import('../screens/TermsOfUse'))
const TrainingList = React.lazy(() => import('../screens/Training/List'))
const TrainingsDetails = React.lazy(() => import('../screens/Training/Details'))


const Routes: React.FC = () => {
    return (
        <BrowserRouter>
            <Suspense fallback={<></>}>
                <Switch>
                    <Route
                        path="/login"
                        exact
                        component={Login}
                    />

                    <Route
                        path="/register"
                        exact
                        component={Register}
                    />

                    <Route
                        path="/user/register/:company_id"
                        exact
                        component={UserRegister}
                    />

                    <Route
                        path="/pass/recover/email"
                        component={PassRecoverSentEmail}
                    />

                    <Route
                        path="/pass/recover/change"
                        component={PassRecoverChange}
                    />

                    <Route
                        path="/terms/"
                        component={TermsOfUse}
                    />

                    <AuthRoute
                        path="/registrationdata"
                        component={RegistrationData}
                    />

                    <AuthRoute
                        path="/user/details/:id"
                        component={UserDetails}
                    />

                    <AuthRoute
                        path="/user/"
                        component={UserList}
                    />

                    <AuthRoute
                        path="/group/details/:id/knowledge/:knowledge_id"
                        component={GroupKnowledge}
                    />

                    <AuthRoute
                        path="/group/details/:id"
                        component={GroupDetails}
                    />

                    <AuthRoute
                        path="/group/:first_time"
                        component={GroupList}
                    />

                    <AuthRoute
                        path="/dashboard/"
                        component={Dashboard}
                    />

                    <AuthRoute
                        path="/training/"
                        component={TrainingList}
                    />

                    <AuthRoute
                        path="/trainings/details/:training_id"
                        component={TrainingsDetails}
                    />

                    <Route
                        path="*"
                        render={() => <Redirect to="/login"/>}
                    />
                </Switch>
            </Suspense>
        </BrowserRouter>
    )
}

export default Routes
